import {useState, useEffect} from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from './TabPanel';
import {setTabOnFocus, toggleRightDrawer, handleSnackBar} from '../../store/global/actions';
import {marginBottomForBreadCrumb} from '../../config/styles';
import {useDispatch } from 'react-redux';
import BreadCrumb from '../atoms/breadcrumb/';
import Divider from '@material-ui/core/Divider';
import {Grid} from '@material-ui/core';
import CreateSimulation from '../molecules/simulations/CreateSimulation';
import EditSimulation from '../molecules/simulations/EditSimulation';
import ContextGenerator from '../molecules/simulations/ContextGenerator';
import ProfileSelector from '../molecules/simulations/ProfileSelector';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import ListSimulationProfiles from '../molecules/simulations/ListSimulationProfiles';
import DeleteSimulationProfileAlert from '../molecules/alerts/DeleteSimulationProfileAlert';

export default function SimulationTabs({element}) {
  const dispatch = useDispatch();
  const [tabActive, setTabActive] = useState(element.action == 'add_transaction' ? 'transaction' : 'simulationInfo');
  const [openTab, setOpenTab] = useState(0);
  const detailsBC = [
    {label: 'Simulation', url: null},
    {label: element.name, url: null},
  ];
  const [action, setAction] = useState(0);

  // to close the 'add profile' page, if the tab is changed from Profile
  if((action.action == "add_profile" || action.action ==  "edit_profile") && openTab != 4){
    setAction({});
  }

  useEffect(() => {
    const tabIndicators = document.getElementsByClassName('MuiTabs-indicator');
    if (tabActive == 'simulationInfo') {
      if (tabIndicators) {
        tabIndicators[0].style.left = '0px';
        tabIndicators[0].style.width = '160px';
      }
    }
    if (tabActive == 'transaction') {
      if (tabIndicators) {
        tabIndicators[0].style.left = '160px';
        tabIndicators[0].style.width = '160px';
      }
      const transactionBtn = document.getElementById('transaction_tab');
      if (transactionBtn) transactionBtn.classList.add('Mui-selected');
    }
    if (tabActive == 'delegate') {
      if (tabIndicators) {
        tabIndicators[0].style.left = '320px';
        tabIndicators[0].style.width = '160px';
      }
      const transactionBtn = document.getElementById('delegate_tab');
      if (transactionBtn) transactionBtn.classList.add('Mui-selected');
    }
  }, [tabActive]);

  const onClose = () => {
    setAction({});
  };

  const onCancel = () => {
    setAction({});
    dispatch(toggleRightDrawer());
  };

  const onCompletion = (action, type, message) => {
    switch (action) {
      case 'add':
        dispatch(handleSnackBar({open: true, message: message ? message : 'Profile added', severity: 'success'}));
        break;

      case 'delete':
        dispatch(handleSnackBar({open: true, message: message ? message : 'Profile deleted', severity: 'success'}));
        break;
    }
    setAction({});
  };

  const decideTabActive = (value) => {
    if (value == 3 || value == 4) {
      setTabActive('simulationInfo');
    }
  };

  return (
    <>
      <AppBar position="static">
        <Tabs
          value={openTab}
          onChange={(e, v) => {
            dispatch(setTabOnFocus(v));
            setOpenTab(v);
            decideTabActive(v);
          }}
          aria-label="SimulationTabs">
          <Tab label="Simulation" disabled={tabActive != 'simulationInfo'} id="simulation_info_tab" />
          <Tab label="Transactions" disabled={tabActive != 'transaction'} id="transaction_tab" />
          <Tab label="Delegates" disabled={tabActive != 'delegate'} id="delegate_tab" />
          <Tab label="Context" id="context_tab" />
          <Tab label="Profile" id="context_tab" />
        </Tabs>
      </AppBar>

      <TabPanel value={openTab} index={0}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={8}>
            <BreadCrumb items={detailsBC} />
          </Grid>
        </Grid>

        <Divider style={marginBottomForBreadCrumb} />

        {element.action === 'create' && <CreateSimulation tabActive={tabActive} setTabActive={setTabActive} onClose={onCancel} />}
        {(element.action === 'edit' || element.action === 'add_transaction') && <EditSimulation tabActive={tabActive} setTabActive={setTabActive} onClose={onCancel} element={element} />}
      </TabPanel>

      <TabPanel value={openTab} index={1}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={8}>
            <BreadCrumb items={[...detailsBC, {label: 'Transactions', url: null}]} />
          </Grid>
        </Grid>

        <Divider style={marginBottomForBreadCrumb} />
      </TabPanel>

      <TabPanel value={openTab} index={2}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={8}>
            <BreadCrumb items={[...detailsBC, {label: 'Delegates', url: null}]} />
          </Grid>
        </Grid>

        <Divider style={marginBottomForBreadCrumb} />
      </TabPanel>

      <TabPanel value={openTab} index={3}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={8}>
            <BreadCrumb items={[...detailsBC, {label: 'Context', url: null}]} />
          </Grid>
        </Grid>

        <Divider style={marginBottomForBreadCrumb} />

        <ContextGenerator onCancel={onCancel} />
      </TabPanel>

      <TabPanel value={openTab} index={4}>
        <Grid container direction={'row'} spacing={2}>
          <Grid item xs={8}>
            <BreadCrumb items={[...detailsBC, {label: 'Profile', url: null}]} />
          </Grid>

          {Object.keys(action).length === 0 && (
            <Grid item xs={4} style={{display: 'flex', justifyContent: 'flex-end'}}>
              <Tooltip title="Create button">
                <span>
                  <Button id="add-profile" onClick={(e) => setAction({action: 'add_profile'})} color="primary" variant="contained" style={{marginLeft: 10, marginBottom: 10}}>
                    Add Profile
                  </Button>
                </span>
              </Tooltip>
            </Grid>
          )}
        </Grid>

        <Divider style={marginBottomForBreadCrumb} />

        {Object.keys(action).length === 0 && <ListSimulationProfiles setAction={setAction} />}
        {action.action == 'add_profile' && <ProfileSelector onClose={onCancel} onCompletion={onCompletion} />}
        {action.action == 'edit_profile' && <ProfileSelector onClose={onCancel} onCompletion={onCompletion} action={action} />}
        {action.action == 'delete_profile' && <DeleteSimulationProfileAlert testsuiteId={element?.id} onClose={onClose} onCompletion={onCompletion} element={action.item} />}
      </TabPanel>
    </>
  );
}
